import React, { useEffect } from "react";
import { Row, Col, Button, Tag, Modal, notification } from "antd";
import { EditOutlined, DeleteOutlined, CopyOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

import api from "../../services/api";
import { useStateValue } from '../../state';
import DrawerNcmSubtituicaoTributaria from './drawer';
import { drawerActions, listagemActions, manutencaoActions } from "../../actions";
import { BreadcrumbIncluirDados, PesquisaOrdenacao, TabelaDados, Editar, Excluir } from "../../components";

export default function NcmSubtituicaoTributaria() {

    const [{ manutencao }, dispatch] = useStateValue();

    useEffect(() => dispatch({ type: listagemActions.CHANGE, data: { filtro: '', ordem: '+ncm_id' } }), []);

    function excluirNcm(record) {
        Modal.confirm({
            title: 'Excluir?',
            icon: <ExclamationCircleOutlined />,
            content: `Deseja realmente excluir este registro?`,
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                excluirRegistro(record);
            }
        });
    };

    function excluirRegistro(record) {
        api.delete(`Ncm/Excluir/${record.ncm_id}`).then(
            res => {
                notification.success({ message: 'Operação concluída', description: "Os dados do NCM foram salvos com sucesso!" });
            }).catch(
                error => {
                    console.log(error);
                }
            ).finally(
                () => {
                    dispatch({ type: listagemActions.CHANGE, data: { ordem: '+ncm_id' } });
                });
    };

    function duplicarNcm(record) {
        record.ncm_id = null;
        dispatch({ type: manutencaoActions.CHANGE, data: { dados: record } });
        dispatch({ type: drawerActions.CHANGE, data: { showDrawer: true } });
    };

    return (
        <div className="p-10">
            <BreadcrumbIncluirDados />
            <PesquisaOrdenacao opcoesOrdenacao={[
                { label: "Nome A - Z", value: "+ncm_descricao" },
                { label: "Nome Z - A", value: "-ncm_descricao" },
                { label: "Código Crescente", value: "+ncm_id" },
                { label: "Código Decrescente", value: "-ncm_id" }
            ]} />
            <div className="tabela">
                <TabelaDados url="ncm/listar" colunas={
                    [
                        {
                            title: 'Código',
                            width: 75,
                            align: 'center',
                            render: ({ ncm_codigo }) => (
                                <Tag color="processing" className="w-100">
                                    <b>{!!ncm_codigo.codigoNcm ? ncm_codigo.codigoNcm : ncm_codigo}</b>
                                </Tag>
                            ),
                        },
                        {
                            title: 'Descrição',
                            render: ({ ncm_descricao }) => (
                                <div>
                                    <b>{ncm_descricao}</b>
                                </div>
                            ),
                        },
                        {
                            title: 'Ações',
                            dataIndex: '',
                            key: 'x',
                            align: 'center',
                            width: 95,
                            fixed: 95,
                            render: (record) => (
                                <div>
                                    <Row align="middle" justify="center" gutter={[5, 0]}>
                                        <Col>
                                            <Button icon={<CopyOutlined />} onClick={() => { duplicarNcm(record) }} />
                                        </Col>
                                        <Col>
                                            <Editar onClick={() => {
                                                dispatch({ type: manutencaoActions.CHANGE, data: { dados: record } });
                                                dispatch({ type: drawerActions.CHANGE, data: { showDrawer: true, editItem: true } });
                                            }} icon={<EditOutlined />} />
                                        </Col>
                                        <Col>
                                            <Excluir icon={<DeleteOutlined />} onClick={() => { excluirNcm(record) }} />
                                        </Col>
                                    </Row>
                                </div>
                            ),
                        },
                    ]
                } expandir={({ cip_entrada, cip_saida, ncm_percentual, ncm_extipi }) => {
                    return (
                        <div>
                            <Row align="middle">
                                <Col md={12} xl={6}>
                                    CST IPI para Entrada: <b>{cip_entrada || 'Não Informado'}</b>
                                </Col>
                                <Col md={12} xl={6}>
                                    CST IPI para Saída: <b>{cip_saida || 'Não Informado'}</b>
                                </Col>
                                <Col md={12} xl={6}>
                                    Alíquota do IPI: <b>{ncm_percentual || 'Não Informado'}</b>
                                </Col>
                                <Col md={12} xl={6}>
                                    Exceção do IPI: <b>{ncm_extipi || 'Não Informado'}</b>
                                </Col>
                            </Row>
                        </div>
                    )
                }} />
            </div>
            <DrawerNcmSubtituicaoTributaria />
        </div>
    );
}